import React from 'react';

import { DamageRow } from './damage-row';

const DamageReport = ({ className, data }) => {
    if (!data) {
        return "No repairs to display.";
    }

    const Titles = () => {
        const titles = ["", "Barcode", "Closet Hacker", "Status", "Replacement", "", "", ""];

        return (
            <tr>
                {titles.map((title, index) => (
                    <th key={`t-${index}`}>{title}</th>
                ))}
            </tr>
        )
    }

    return (
        <table className={`table is-fullwidth ${className}`}>
            <thead>
                <Titles />
            </thead>
            <tfoot>
                <Titles />
            </tfoot>
            <tbody>
                {data.map((report, index) => (
                    <DamageRow key={`row-${index}`} report={report} count={index + 1} />
                ))}
            </tbody>
        </table>
    );
}

export { DamageReport };
